var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailsWithdrawal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36,
    r: 35.5,
    fill: "#F3F5F7",
    stroke: "#E6E7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1001 39.2202V42.9261C28.1001 43.4877 28.3213 44.0264 28.7152 44.4235C29.109 44.8206 29.6431 45.0438 30.2001 45.0438H42.8001C43.3571 45.0438 43.8912 44.8206 44.285 44.4235C44.6788 44.0264 44.9001 43.4877 44.9001 42.9261V39.2202M36.5435 38.957L36.5435 26.957M36.5435 26.957L31.7435 31.5422M36.5435 26.957L41.3434 31.5422",
    stroke: "#F8009E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsWithdrawal);
export default __webpack_public_path__ + "static/media/DetailsWithdrawal.d0c674afafe2af297d66470ff661951b.svg";
export { ForwardRef as ReactComponent };